import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOChControl } from "../models/BOChControl.model";


export interface RespuestaDrive {
  success: boolean;
  existe: boolean;
  fileId?: string | null;
  message?: string;
}

@Injectable({
  providedIn: 'root'
}

)
export class ClinicHistoryPdfService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/ClinicHistoryPdf/';

    constructor(private http:HttpClient){}

  uploadPdf(clinicHistoryId: number, pdfBlob: Blob): Observable<any> {
     console.log("EN UPLOADPDF clinicHisstoryId es:", clinicHistoryId, " blob es:", pdfBlob);
      const formData = new FormData();
      formData.append('file', pdfBlob, `HistoriaClinica_${clinicHistoryId}.pdf`);
      formData.append('fileName', clinicHistoryId.toString()
    );
    return this.http.post<any>(this.myAppUrl + this.myApiUrl+'upload', formData );
  }


updatePdf(fileId: string, blob: Blob): Observable<any> {
  const formData = new FormData();
  formData.append('file', blob, `${fileId}.pdf`);

 // return this.http.put<any>(`${this.apiUrl}/update/${fileId}`, formData);
  return this.http.put<any>(this.myAppUrl + this.myApiUrl+'update/'+fileId, formData );

}

  verifyExist(numHistoria: string): Observable<RespuestaDrive> {
    return this.http.get<RespuestaDrive>(this.myAppUrl + this.myApiUrl+'exists/' +numHistoria);
  }

}
